import { DependencyList, useCallback, useRef } from "react";

import __ from "web/Layout/Translations";

import useSlidesAccessibility from "web/hooks/useAccessibleSwiperCarousel/useSlidesAccessibility";

interface SwiperCarouselInstance {
  keyboard?: { enable(): void; disable(): void };
  realIndex: number;
}

interface UseAccessibleSwiperCarouselArgs {
  deps: DependencyList;
}

const useAccessibleSwiperCarousel = ({
  deps,
}: UseAccessibleSwiperCarouselArgs) => {
  const swiperRef = useRef<SwiperCarouselInstance | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const enableKeyboard = useCallback(() => {
    swiperRef.current?.keyboard?.enable();
  }, []);

  const disableKeyboard = useCallback(() => {
    swiperRef.current?.keyboard?.disable();
  }, []);

  useSlidesAccessibility({
    containerRef,
    deps,
  });

  return {
    containerRef,
    swiperRef,
    containerProps: {
      ref: containerRef,
      onFocus: enableKeyboard,
      onBlur: disableKeyboard,
    },
    swiperA11yProps: {
      a11y: {
        enabled: true as const,
        prevSlideMessage: __("Poprzedni slajd"),
        nextSlideMessage: __("Następny slajd"),
        slideLabelMessage: "",
      },
      keyboard: { enabled: true as const },
      tabIndex: 0,
      role: "region" as const,
      "aria-roledescription": "carousel" as const,
    },
  };
};

export default useAccessibleSwiperCarousel;
